export default __webpack_public_path__ + "static/media/TimesUp.a34f91ba.mp3";